// import React, { Component } from 'react';
// import Cookies from 'universal-cookie';
// import Header from '../components/dashboardSubComponents/header'
// import SideBar from '../components/dashboardSubComponents/sideBarNav'
// import { Loader } from 'react-overlay-loader';
// import { url } from '../components/helper'
// import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

// class ResetPassword extends Component {

//     constructor(props) {
//         super(props)
//         this.state = {
//             "btn_disabled": true,
//             loading: false,
//             noEmailMessage: null,
//             noEmailMessageHidden: true,
//             passwordMismatchErrorhidden: true,
//             passwordViewicon: "fa fa-eye passviewicon",
//             messageModalOpen: false,
//             messageTitle: null,
//             messageBody: null,
//             messageType: 0
//         }
//         this.validatePasswordFields = this.validatePasswordFields.bind(this)
//         this.changePassword = this.changePassword.bind(this)
//         this.cloaseMessageBox = this.cloaseMessageBox.bind(this)
//         this.toggleOldPasswordView = this.toggleOldPasswordView.bind(this)
//         this.matchOnNEwPassword = this.matchOnNEwPassword.bind(this)
//     }

//     validatePasswordFields = () => {
//         var n_password = document.getElementById("NewPassword")
//         n_password = n_password.value
//         var c_password = document.getElementById("confirmPassword")
//         c_password = c_password.value

//         if (n_password === c_password) {
//             this.setState({
//                 "btn_disabled": false,
//                 passwordMismatchErrorhidden: true
//             })
//         }
//         else {
//             this.setState({
//                 "btn_disabled": true,
//                 passwordMismatchErrorhidden: false
//             })
//         }
//     }

//     matchOnNEwPassword = () => {
//         var n_password = document.getElementById("NewPassword")
//         n_password = n_password.value
//         var c_password = document.getElementById("confirmPassword")
//         c_password = c_password.value

//         if (c_password !== "" && n_password !== "") {
//             if (n_password === c_password) {
//                 this.setState({
//                     "btn_disabled": false,
//                     passwordMismatchErrorhidden: true
//                 })
//             }
//             else {
//                 this.setState({
//                     "btn_disabled": true,
//                     passwordMismatchErrorhidden: false
//                 })
//             }
//         }
//     }

//     cloaseMessageBox = () => {
//         if (this.state.messageType === 0) {
//             this.setState({
//                 messageModalOpen: false
//             })
//         }
//         if (this.state.messageType === 1) {
//             this.setState({
//                 messageModalOpen: false
//             })
//             window.location = '/dashboard'
//         }
//     }

//     changePassword = () => {
//         this.setState({
//             loading: true
//         })
//         var cookes = new Cookies();
//         var username = cookes.get('username')
//         var token = cookes.get('token')

//         var password = document.getElementById("NewPassword").value
//         var oldpassword = document.getElementById("OldPassword").value
//         var http = new XMLHttpRequest()
//         if (password === oldpassword) {
//             this.setState({
//                 noEmailMessageHidden: false,
//                 noEmailMessage: "Old password and new password can not be same. Please choose different password.",
//                 loading: false
//             })
//             return
//         }
//         var dashboar_ref = this
//         http.open('PUT', url + '/api/user/reset_password', true);
//         http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
//         http.setRequestHeader("Authorization", "Bearer " + token)
//         //("&username="+username+"&new_password="+password+"&old_password="+oldpassword)
//         http.send("&username=" + username + "&new_password=" + password + "&old=" + oldpassword)
//         http.onreadystatechange = function () {
//             if (http.readyState === 4 && http.status === 200) {
//                 //(http.responseText)
//                 var json = JSON.parse(http.responseText)
//                 if (json.status === 200) {
//                     dashboar_ref.setState({
//                         loading: false,
//                         noEmailMessageHidden: true,
//                         messageTitle: "Password Changed",
//                         messageBody: "Your password has been changed. You are going to be redirected to dashboard page",
//                         messageType: 1,
//                         messageModalOpen: true
//                     })

//                 }
//                 else {
//                     dashboar_ref.setState({
//                         noEmailMessageHidden: false,
//                         noEmailMessage: "Could Not Reset Password",
//                         loading: false
//                     })
//                 }
//             }
//             else {
//                 dashboar_ref.setState({
//                     noEmailMessageHidden: false,
//                     noEmailMessage: "Could Not Reset Password",
//                     loading: false
//                 })
//             }
//         }
//         http.onerror = function () {
//             dashboar_ref.setState({
//                 noEmailMessageHidden: false,
//                 noEmailMessage: "Could Not Reset Password",
//                 loading: false
//             })
//         }
//     }

//     togglePasswordView = () => {
//         var input = document.getElementById("NewPassword")
//         if (input.type === "password") {
//             input.type = "text"
//             this.setState({
//                 passwordViewicon: "fas fa-eye-slash passviewicon"
//             })
//         }
//         else {
//             input.type = "password"
//             this.setState({
//                 passwordViewicon: "fas fa-eye passviewicon"
//             })
//         }
//     }

//     toggleOldPasswordView = () => {
//         var input = document.getElementById("OldPassword")
//         if (input.type === "password") {
//             input.type = "text"
//             this.setState({
//                 passwordViewicon: "fas fa-eye-slash passviewicon"
//             })
//         }
//         else {
//             input.type = "password"
//             this.setState({
//                 passwordViewicon: "fas fa-eye passviewicon"
//             })
//         }
//     }

//     render() {
//         return (

//             <div>
//                 <div className="clearfix" id="page-header">
//                     <div>
//                         <Header />
//                     </div>
//                 </div>

//                 <div >
//                     <SideBar />
//                 </div>
//                 <div id="page-content-wrapper" className="rm-transition">
//                     <div id="page-content">
//                         <form id="login-validation" className="col-md-4 center-margin" >
//                             <Loader loading={this.state.loading} fullPage={true} />
//                             <Modal isOpen={this.state.messageModalOpen}>
//                                 <ModalHeader>{this.state.messageTitle}</ModalHeader>
//                                 <ModalBody>
//                                     <b>{this.state.messageBody}</b>
//                                 </ModalBody>
//                                 <ModalFooter>
//                                     <Button onClick={this.cloaseMessageBox}>Close</Button>
//                                 </ModalFooter>
//                             </Modal>
//                             <div id="login-form" className="content-box modal-content">

//                                 <div className="content-box-wrapper pad20A">

//                                     <div className="form-group">
//                                         <label htmlFor="exampleInputPassword1">Old Password:</label>
//                                         <div className="input-group input-group-lg">
//                                             <i class="fas fa-key inputicon" ></i>
//                                             <input type="password" className="form-control" id="OldPassword" placeholder="Enter Old Password"></input>
//                                             <i className={this.state.passwordViewicon} title="Show password" onClick={this.toggleOldPasswordView.bind(this)}></i>
//                                         </div>
//                                     </div>

//                                     <div className="form-group">
//                                         {/* <label htmlFor="exampleInputEmail1">Email address:</label> */}
//                                         <label htmlFor="exampleInputPassword1">New Password:</label>
//                                         <div className="input-group input-group-lg">
//                                             <i class="fas fa-key inputicon" ></i>
//                                             <input type="password" className="form-control" id="NewPassword" onBlur={this.matchOnNEwPassword} placeholder="Enter New Password"></input>
//                                             <i className={this.state.passwordViewicon} title="Show password" onClick={this.togglePasswordView.bind(this)}></i>
//                                         </div>
//                                     </div>
//                                     <div className="form-group">
//                                         {/* <label htmlFor="exampleInputPassword1">Confirm </label> */}
//                                         <label htmlFor="exampleInputPassword1">Confirm Password:</label>
//                                         <div className="input-group input-group-lg">
//                                             <i class="fas fa-key inputicon" ></i>
//                                             <input type="password" className="form-control" id="confirmPassword" placeholder="Confirm Password" onBlur={this.validatePasswordFields}></input>
//                                         </div>
//                                         <div class="isa_error" hidden={this.state.passwordMismatchErrorhidden}>
//                                             <i class="fa fa-times-circle"></i>
//                                             <b>Passwords do not match</b>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div className="button-pane">
//                                     <div style={{ marginBottom: 3 }} hidden={this.state.noEmailMessageHidden}>
//                                         <i class="fa fa-times-circle"></i>
//                                         <b style={{ textAlign: "left" }}>{this.state.noEmailMessage}</b>
//                                     </div>
//                                     <button type="button" className="btn btn-block btn-primary" disabled={this.state.btn_disabled} onClick={this.changePassword} >Save Password</button>
//                                 </div>
//                             </div>
//                         </form>
//                     </div>
//                 </div>
//             </div>

//         )
//     }
// }

// export default ResetPassword;

import React from 'react'
import { Loader } from 'react-overlay-loader'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import Cookies from 'universal-cookie'
import Header from '../components/dashboardSubComponents/header'
import SideBar from '../components/dashboardSubComponents/sideBarNav'
import { url } from '../components/helper'

const ResetPassword = () => {
    const [btnDisabled, setBtnDisabled] = React.useState(true)
    const [loading, setLoading] = React.useState(false)
    const [noEmailMessage, setNoEmailMessage] = React.useState(null)
    const [noEmailMessageHidden, setNoEmailMessageHidden] = React.useState(true)
    const [passwordMismatchErrorHidden, setPasswordMistmatchErrorHidden] =
        React.useState(true)
    const [passwordViewIcon, setPasswordViewIcon] = React.useState(
        'fa fa-eye passviewicon'
    )
    const [messageModalOpen, setMessageModalOpen] = React.useState(false)
    const [messageTitle, setMessageTitle] = React.useState(null)
    const [messageBody, setMessageBody] = React.useState(null)
    const [messageType, setMessageType] = React.useState(0)

    // Validates Password Fields and Validates Confirm password and New password
    const validatePasswordFields = () => {
        const n_password = document.getElementById('NewPassword').value
        const c_password = document.getElementById('confirmPassword').value
        const o_password = document.getElementById('OldPassword').value

        // If any fields are empty
        const any_password_fields_empty =
            o_password === '' || n_password === '' || c_password === ''

        // Check if confirm matches new password
        const new_match_confirm = c_password === n_password

        // Disable enable accordingly
        setBtnDisabled(any_password_fields_empty || !new_match_confirm)
        setPasswordMistmatchErrorHidden(new_match_confirm)
    }

    //Close the message board based on message type
    const closeMessageBox = () => {
        setMessageModalOpen(messageType === 0 || messageType === 1)
        if (messageType === 1) {
            window.location = '/dashboard'
        }
    }

    //Password toggle button for New Password
    const toggleNewPasswordView = () => {
        const input = document.getElementById('NewPassword')
        if (input.type === 'password') {
            input.type = 'text'
            setPasswordViewIcon('fas fa-eye-slash passviewicon')
        } else {
            input.type = 'password'
            setPasswordViewIcon('fas fa-eye passviewicon')
        }
    }

    //Password toggle button for New Password
    const toggleOldPasswordView = () => {
        const input = document.getElementById('OldPassword')
        if (input.type === 'password') {
            input.type = 'text'
            setPasswordViewIcon('fas fa-eye-slash passviewicon')
        } else {
            input.type = 'password'
            setPasswordViewIcon('fas fa-eye passviewicon')
        }
    }

    //Handle changing password
    const changePassword = async () => {
        setLoading(true)
        const cookies = new Cookies()
        const username = cookies.get('username')
        const token = cookies.get('token')

        const password = document.getElementById('NewPassword').value
        const oldPassword = document.getElementById('OldPassword').value

        const newLogin = {
            username: username,
            new_password: password,
            old_password: oldPassword,
        }

        console.log('NEWLOGIN', newLogin)

        const options = {
            method: 'PUT',
            headers: {
                'Content-type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams(Object.entries(newLogin)).toString(),
        }

        try {
            const res = await fetch(`${url}/api/user/reset_password`, options)
            const data = await res.json()
            // console.log('DATA', data.status)
            switch (data.status) {
                case 200:
                    setLoading(false)
                    setNoEmailMessageHidden(false)
                    setMessageTitle('Password Changed')
                    setMessageBody('Your password has been changed')
                    setMessageType(1)
                    setMessageModalOpen(true)
                    break
                default:
                    setNoEmailMessageHidden(false)
                    setNoEmailMessage('Could Not Reset Password')
                    setLoading(false)
                    break
            }
        } catch (err) {
            setNoEmailMessageHidden(false)
            setNoEmailMessage('Could Not Reset Password')
            setLoading(false)
        }

        //PFIX: Should we add it such that the confirm password view toggle trigger has its own button or have it be tied to the new password?
    }
    return (
        <div>
            <div className="clearfix" id="page-header">
                <div>
                    <Header />
                </div>
            </div>

            <div>
                <SideBar />
            </div>
            <div id="page-content-wrapper" className="rm-transition">
                <div id="page-content">
                    <form
                        id="login-validation"
                        className="col-md-4 center-margin"
                    >
                        <Loader loading={loading} fullPage={true} />
                        <Modal isOpen={messageModalOpen}>
                            <ModalHeader>{messageTitle}</ModalHeader>
                            <ModalBody>
                                <b>{messageBody}</b>
                            </ModalBody>
                            <ModalFooter>
                                <Button onClick={closeMessageBox}>Close</Button>
                            </ModalFooter>
                        </Modal>
                        <div
                            id="login-form"
                            className="content-box modal-content"
                        >
                            <div className="content-box-wrapper pad20A">
                                <div className="form-group">
                                    <label htmlFor="exampleInputPassword1">
                                        Old Password:
                                    </label>
                                    <div className="input-group input-group-lg">
                                        <i class="fas fa-key inputicon"></i>
                                        <input
                                            type="password"
                                            className="form-control"
                                            id="OldPassword"
                                            placeholder="Enter Old Password"
                                            onBlur={validatePasswordFields}
                                        ></input>
                                        <i
                                            className={passwordViewIcon}
                                            title="Show password"
                                            onClick={toggleOldPasswordView}
                                        ></i>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label htmlFor="exampleInputPassword1">
                                        New Password:
                                    </label>
                                    <div className="input-group input-group-lg">
                                        <i class="fas fa-key inputicon"></i>
                                        <input
                                            type="password"
                                            className="form-control"
                                            id="NewPassword"
                                            onBlur={validatePasswordFields}
                                            placeholder="Enter New Password"
                                        ></input>
                                        <i
                                            className={passwordViewIcon}
                                            title="Show password"
                                            onClick={toggleNewPasswordView}
                                        ></i>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="exampleInputPassword1">
                                        Confirm Password:
                                    </label>
                                    <div className="input-group input-group-lg">
                                        <i class="fas fa-key inputicon"></i>
                                        <input
                                            type="password"
                                            className="form-control"
                                            id="confirmPassword"
                                            placeholder="Confirm Password"
                                            onBlur={validatePasswordFields}
                                        ></input>
                                    </div>
                                    <div
                                        class="isa_error"
                                        hidden={passwordMismatchErrorHidden}
                                    >
                                        <i class="fa fa-times-circle"></i>
                                        <b>Passwords do not match</b>
                                    </div>
                                </div>
                            </div>
                            <div className="button-pane">
                                <div
                                    style={{ marginBottom: 3 }}
                                    hidden={noEmailMessageHidden}
                                >
                                    <i class="fa fa-times-circle"></i>
                                    <b style={{ textAlign: 'left' }}>
                                        {noEmailMessage}
                                    </b>
                                </div>
                                <button
                                    type="button"
                                    className="btn btn-block btn-primary"
                                    disabled={btnDisabled}
                                    onClick={changePassword}
                                >
                                    Save Password
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default ResetPassword

/**
 * Notes:
 * - Tested
 * - A lot of repeated code
 * - Some states might be unnecessary
 */



// WEBPACK FOOTER //
// src/Routes/ResetPassword.js